import type { PropsWithChildren } from 'react'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { BudgetCategoryCardDetailsBreakdownRow } from '../BudgetCategoryCardDetailsBreakdownRow'
import { BudgetCategoryCardDetailsBreakdownVarianceRow } from '../BudgetCategoryCardDetailsBreakdownVarianceRow'
import { BudgetCategoryCardDetailsBreakdownStyled } from './styles/BudgetCategoryCardDetailsBreakdownStyled'

export interface IBudgetCategoryCardDetailsBreakdownProps {
  ariaLabel?: string
}

export const BudgetCategoryCardDetailsBreakdown = ({
  ariaLabel,
  children,
}: PropsWithChildren<IBudgetCategoryCardDetailsBreakdownProps>) => {
  return (
    <BudgetCategoryCardDetailsBreakdownStyled>
      <CostSummary ariaLabel={ariaLabel}>{children}</CostSummary>
    </BudgetCategoryCardDetailsBreakdownStyled>
  )
}

BudgetCategoryCardDetailsBreakdown.displayName =
  'BudgetCategoryCardDetailsBreakdown'
BudgetCategoryCardDetailsBreakdown.Row = BudgetCategoryCardDetailsBreakdownRow
BudgetCategoryCardDetailsBreakdown.VarianceRow =
  BudgetCategoryCardDetailsBreakdownVarianceRow
